// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CartController from "./cart_controller"
application.register("cart", CartController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import ProductQuantityController from "./product_quantity_controller"
application.register("product-quantity", ProductQuantityController)
